export default "__VITE_ASSET__0rYfam80Z_WvbGdZeAnvdw__"